import { createSlice } from '@reduxjs/toolkit'

type authState = {
  period: boolean
  available: boolean
  loginType: string | number
}

const initialState: authState = {
  // jwtToken: false,
  period: false,
  available: false,
  loginType: '',
  // pageToggle: false,
}

const authReducer = createSlice({
  name: 'jwtToken',
  initialState: initialState,
  reducers: {
    periodState(state, action) {
      state.period = action.payload
    },
    availableState(state, action) {
      state.available = action.payload
    },
    loginTypeState(state, action) {
      state.loginType = action.payload
    },
  },
})

export const { periodState, availableState, loginTypeState } = authReducer.actions

export default authReducer.reducer
